import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../shared/services/api.service';
import {Contact} from '../../../entities';
import {MERCHANT_WEBAPP_URL, MERCHANT_WEBAPP_USER, MERCHANT_WEBAPP_PASSWORD, PIMCORE} from '../../../app.constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {MerchantService} from '../../../shared/services/merchant.service';
import { JhiLanguageService } from 'ng-jhipster';

export interface Credentials {
  username: string;
  password: string;
}
export interface AuthData {
  token: string;
  merchantId: number;
  termsOfUse: boolean;
  ts: string;
  role: 'ReadonlyAdmin' | 'Merchant';
}

@Component({
  selector: 'app-marketwebsite-merchants-help',
  templateUrl: './marketwebsite-merchants-help.component.html',
  styles: []
})
export class MarketwebsiteMerchantsHelpComponent implements OnInit {

  public loading = false;
  public notFoundError = false;
  public merchantNumber: string;
  public contact: Contact;

  public modalRef = null;

  public merchantWebappUrl = MERCHANT_WEBAPP_URL;
  public loginUrl: string;


  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private merchantService: MerchantService,
    private jhiLanguageService: JhiLanguageService
  ) {
    this.jhiLanguageService.setLocations(['home']);
  }

  ngOnInit() {

  }


  searchMerchant() {
    this.contact = null;
    this.loginUrl = null;
    if (this.merchantNumber !== null && this.merchantNumber !== '') {
      this.merchantService.searchMerchant(this.merchantNumber).then(contact => {
        if (contact) {
          this.contact = contact;
          this.notFoundError = false;
          this.getLoginUrl();
        } else {
          this.notFoundError = true;
        }
      }).catch(error => {this.notFoundError = true; this.loading = false; });
    }
  }

  getLoginUrl() {
    const credentials: Credentials = {
      username: MERCHANT_WEBAPP_USER,
      password: MERCHANT_WEBAPP_PASSWORD
    };
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: 'Basic ' + window.btoa(credentials.username + ':' + credentials.password)
    });
    const url = PIMCORE + ['api', 'de', 'merchants', 'user', 'token'].join('/')
      + (this.contact.merchantNumber ? '?merchantNumber=' + this.contact.merchantNumber : '');
    this.http.post(
      url,
      null,
      {headers}
    ).subscribe(
      (authData) => {
        const authDataString = JSON.stringify(authData);
        this.loginUrl = MERCHANT_WEBAPP_URL + '/admin?adminToken=' + authDataString;
        // window.open(MERCHANT_WEBAPP_URL + '/admin?adminToken=' + authDataString, '_blank');
      }
    );
  }

  open() {
    window.open(this.loginUrl, '_blank');
  }


}



// WEBPACK FOOTER //
// ./src/app/administration/components/marketwebsite-merchants-help/marketwebsite-merchants-help.component.ts